import * as React from "react";

interface ToggleProps {
  activeTab: "upcoming" | "ondemand";
  onToggle: (tab: "upcoming" | "ondemand") => void;
  openContact: () => void;
}

export const Toggle: React.FC<ToggleProps> = ({ activeTab, onToggle, openContact }) => {
  // Create refs for the buttons
  const upcomingRef = React.useRef<HTMLButtonElement>(null);
  const ondemandRef = React.useRef<HTMLButtonElement>(null);

  // Handle keyboard navigation
  const handleKeyDown = (e: React.KeyboardEvent, tab: "upcoming" | "ondemand") => {
    switch (e.key) {
      case "Enter":
      case " ": // Space
        e.preventDefault();
        onToggle(tab);
        break;
      case "ArrowLeft":
        e.preventDefault();
        onToggle("upcoming");
        upcomingRef.current?.focus();
        break;
      case "ArrowRight":
        e.preventDefault();
        onToggle("ondemand");
        ondemandRef.current?.focus();
        break;
    }
  };
  const buttonStyle = `max-xl:!tw-text-lg max-sm:!tw-text-sm tw-rounded-full tw-p-8 tw-py-4 tw-font-bold tw-transition-all !focus:tw-outline-none focus-visible:tw-ring-2 focus-visible:tw-ring-[#00E6C3] focus-visible:tw-ring-offset-2 focus-visible:tw-ring-offset-black tw-text-white`;
  const hoverStyle = `tw-text-white/70 hover:tw-text-white`;
  const activeStyle = `btn-gradient tw-text-white`;

  return (
    <div className="tw-mb-8 tw-flex tw-justify-center" role="tablist" aria-label="Training sections">
      <div className="tw-flex tw-flex-col tw-items-center tw-gap-4">
        <div className="tw-flex tw-rounded-full tw-border tw-border-white/10 tw-bg-[#1A1A1A]">
          <button
            ref={upcomingRef}
            onClick={() => onToggle("upcoming")}
            onKeyDown={e => handleKeyDown(e, "upcoming")}
            role="tab"
            aria-selected={activeTab === "upcoming"}
            aria-controls="upcoming-panel"
            tabIndex={activeTab === "upcoming" ? 0 : -1}
            className={`${buttonStyle} tw-rounded-br-none tw-rounded-tr-none ${activeTab === "upcoming" ? activeStyle : hoverStyle}`}
          >
            Upcoming
          </button>
          <button
            ref={ondemandRef}
            onClick={() => onToggle("ondemand")}
            onKeyDown={e => handleKeyDown(e, "ondemand")}
            role="tab"
            aria-selected={activeTab === "ondemand"}
            aria-controls="ondemand-panel"
            tabIndex={activeTab === "ondemand" ? 0 : -1}
            className={`${buttonStyle}  tw-rounded-bl-none tw-rounded-tl-none ${activeTab === "ondemand" ? activeStyle : hoverStyle}`}
          >
            On demand
          </button>
        </div>
      </div>
    </div>
  );
};
